import { render, staticRenderFns } from "./CentralRoomOrder.vue?vue&type=template&id=14a08520&scoped=true&"
import script from "./CentralRoomOrder.vue?vue&type=script&lang=js&"
export * from "./CentralRoomOrder.vue?vue&type=script&lang=js&"
import style0 from "./CentralRoomOrder.vue?vue&type=style&index=0&id=14a08520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a08520",
  null
  
)

export default component.exports